/**
 * To get unique file name for attachment
 * eg: if file name is filename.jpg, it will return filename (1).jpg, filename (2).jpg etc 
 * (if file already exists)
 * @param {*} currentFileName 
 * @param {*} existingFiles 
 * @returns 
 */
export const getUniqueFileName = (currentFileName, existingFiles) => {
  const existingNames = new Set(existingFiles.map(a => a?.attachment_name));
  if (!existingNames.has(currentFileName)) return currentFileName;

  const lastDot = currentFileName.lastIndexOf('.');
  const name = lastDot > 0 ? currentFileName.substring(0, lastDot) : currentFileName;
  const ext = lastDot > 0 ? currentFileName.substring(lastDot) : '';

  let counter = 1;
  let newName;
  do {
    newName = `${name} (${counter})${ext}`;
    counter++;
  } while (existingNames.has(newName));

  return newName;
};
